import Button from "./Buttons/Button"
import Text from "./Text"

const ItemScrollbar = ({
    itemType = "",
    items,
    onClickAction,
    itemDisplayOption = null,
    colorDisplayOption = null,
    borderOptions = "border border-black rounded-md",
    color = "bg-gray-200" }) => {

    const ItemButtonField = ({ item }) => (

        <Button onClickAction={() => onClickAction(item)} text={itemDisplayOption ? itemDisplayOption(item) : null} overflow="" buttonColor={colorDisplayOption ? null : "bg-white"} classNames="flex-row p-3 items-center" style={{ backgroundColor: colorDisplayOption ? colorDisplayOption(item) : null }} />
    )

    return (
        <div className={`w-full flex flex-row gap-1 ${borderOptions} ${color} p-1 overflow-x-auto`}>
            {items?.length > 0 ? items?.map((item, index) => (
                <ItemButtonField key={item.id || index} item={item} />
            )) : <Text type="maintitle" classNames={"flex justify-center itemscenter"}>Keine {itemType} vorhanden</Text>
            }
        </div>
    )
}
export default ItemScrollbar